module.exports = __webpack_public_path__ + "img/ep-J.80e36684.jpg";